export default __webpack_public_path__ + "static/media/clock yellow hive.71db98c1.svg";